<div class="floatingFooter">
    <ng-container *ngIf="doubleButton">
        <button class="btn btn-i btn-lg pull-left" [disabled]="leftButtonDisabled" [ngClass]="{'btn-hidden':leftButtonHidden}">
            <span [i18n]="[{target: 'innerHTML', key: leftLabelKey}]" (click)="handleLeftButtonActionEvent($event)"></span>
        </button>
    </ng-container>
    <span *ngIf="displayError">{{errorMessageKey}}</span>

    <button class="btn btn-primary btn-lg pull-right" [disabled]="rightButtonDisabled" [ngClass]="{'btn-hidden':rightButtonHidden}">
        <span [i18n]="[{target: 'innerHTML', key: rightLabelKey}]" (click)="handleRightButtonActionEvent($event)"></span>
    </button>
</div>
